module.exports = __webpack_public_path__ + "img/App-Store.f6447fff.png";